import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography';
import CustomizedSwitch from "../../CustomizedSwitch/CustomizedSwitch"

const styles = () => ({
    selectRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    switch: {
        position: 'relative',
        left: 15,
    },
})

const SidebarCheckbox = ({ classes, label, checked, change }) => (
    <div style={styles.selectRow}>
        <Typography variant={'body1'}>{label}</Typography>
        <CustomizedSwitch
            style={styles.switch}
            // color="primary"//
            checked={checked}
            onChange={change}
        />
    </div>
)


SidebarCheckbox.defaultprops = {
    checked: false,
}

SidebarCheckbox.prototype = {
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    change: PropTypes.func.isRequired,
}

export default SidebarCheckbox